













































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class AmountInput extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {
    title: '金额（元）',
    placeholder: '请输入金额',
    required: false,
    showUppercase: true,
  };
  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }
}
